import { put } from "@redux-saga/core/effects";
import { all, takeEvery,  call } from 'redux-saga/effects'
// import { toast } from 'react-toastify';
// import { clientListing } from "../../services/clientListingServices";
// import { getbalanceresponse } from "../../services/getbalanceservice";
// import { getbalancerequest, getbalancesuccess, getbalancefailure } from "./action";
// import { GET_BALANCE } from "./types";
import { getprofileserviicesresponse } from "../../services/getprofileservices";
import { GET_PROFILE } from "./types";
import { getprofilerequest,getprofilesuccess,getprofilefailure } from "./action";





export function* getprofile(){
    
    
    yield put(getprofilerequest())
    try{
        
        const result = yield call(getprofileserviicesresponse);
        // if (result.status == "ACTIVE") {
            yield put(getprofilesuccess(result));
            // toast.success(" Successfully")
        // } else {

            // yield put(getprofilefailure(result))
            // toast("FailListing")
        // }

    }catch(error){

        // yield put(getprofilefailure(error.response.data))

        // toast.error("Validation Error listing")

    }

}

export default function* GetprofilelistSaga() {
    
    yield all([takeEvery(GET_PROFILE, getprofile)])
}
